import {
    ActionTypes,
    CheckoutsTermsLoadAction,
    CheckoutsTermsLoadErrorAction,
    CheckoutsTermsLoadSuccessAction,
    CheckoutsTermsState,
    CheckoutsTermsUpdateAction,
    CheckoutsTermsUpdateErrorAction,
    CheckoutsTermsUpdateSuccessAction,
    CheckoutsTermsModifyErrorAction,
    CheckoutsTermsModifySuccessAction,
    CheckoutsTermsPayload
} from './types';
import { ApplicationState } from '..';


export const CheckoutsTermsLoadStart = (): CheckoutsTermsLoadAction => ({
    type: ActionTypes.LOAD_START
});
export const CheckoutsTermsLoadSuccess = (payload: CheckoutsTermsPayload): CheckoutsTermsLoadSuccessAction => ({
    type: ActionTypes.LOAD_SUCCESS,
    payload,
});
export const CheckoutsTermsLoadError = (): CheckoutsTermsLoadErrorAction => ({
    type: ActionTypes.LOAD_ERROR,
});


export const CheckoutsTermsUpdate = (payload: CheckoutsTermsPayload): CheckoutsTermsUpdateAction => ({
    type: ActionTypes.UPDATE_START,
    payload,
});
export const CheckoutsTermsUpdateSuccess = (payload: CheckoutsTermsPayload): CheckoutsTermsUpdateSuccessAction => ({
    type: ActionTypes.UPDATE_SUCCESS,
    payload,
});
export const CheckoutsTermsUpdateError = (): CheckoutsTermsUpdateErrorAction => ({
    type: ActionTypes.UPDATE_ERROR,
});

export const CheckoutsTermsModifySuccess = (payload: CheckoutsTermsPayload): CheckoutsTermsModifySuccessAction => ({
    type: ActionTypes.MODIFY_SUCCESS,
    payload,
});
export const CheckoutsTermsModifyError = (): CheckoutsTermsModifyErrorAction => ({
    type: ActionTypes.MODIFY_ERROR,
});


export const getCheckoutsTermsStore = (store: ApplicationState): CheckoutsTermsState => store.checkoutsTerms || {} as CheckoutsTermsState;